import React from 'react'
import SentCampaignItem from './sentCampaignItem'
const ListSentCampaign = () => {
  return (
    <div className='animate-fade-in-down'>
      <SentCampaignItem/>
    </div>
  )
}

export default ListSentCampaign